import { Reveal, Overline } from "./Reveal";
import { Layers, Users, ShieldCheck, Rocket, Network, Handshake } from "lucide-react";

const reasons = [
  { icon: Layers, title: "End-to-End Delivery", body: "A single accountable partner from architecture and engineering through deployment and support." },
  { icon: Users, title: "Experienced Engineering Team", body: "Senior engineers with deep domain expertise across telecom, cloud, security and automation." },
  { icon: ShieldCheck, title: "Enterprise-Grade Solutions", body: "Built for security, compliance, and reliability at the scale demanded by large organizations." },
  { icon: Rocket, title: "Innovation-Focused Approach", body: "We apply AI and emerging technology pragmatically to create measurable business impact." },
  { icon: Network, title: "Scalable Architecture", body: "Systems designed to grow — from first deployment to global, high-throughput workloads." },
  { icon: Handshake, title: "Long-Term Partnership", body: "We invest in your roadmap, operating and evolving your platforms well beyond launch." },
];

export const WhyChoose = () => (
  <section id="why" className="relative z-10 border-t border-white/10 bg-ink-900/40 py-24 md:py-32" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal><Overline>Why Choose Team-X</Overline></Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
          The engineering partner enterprises trust to deliver.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/5 sm:grid-cols-2 lg:grid-cols-3">
        {reasons.map((r, i) => {
          const Icon = r.icon;
          return (
            <Reveal
              key={r.title}
              delay={(i % 3) * 0.06}
              className="group bg-ink-950 p-8 transition-colors duration-500 hover:bg-ink-900"
              data-testid={`why-card-${i}`}
            >
              <Icon className="h-8 w-8 text-brand transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-white">{r.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{r.body}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
